import React from 'react';
import '../assets/css/Home.css';
import heroImage from '../assets/home-page-imgs/hero.png';
import sbcbanner from '../assets/SBC-Gallery/SBC-joiners.PNG';
import cap from '../assets/icons/cap.png';
import certified from '../assets/icons/certified.png';
import grow from '../assets/icons/grow.png';
import PopularCourses from './PopularCourses';
import Hero from '../components/Hero';
import GurukulOffers from './GurukulOffers';
import PartnerGet from './PartnerGet';

const Home = () => {
    return (

        <>
            {/* <section className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">Empowering Real Estate Knowledge for the Future</h1>
                    <p className="hero-subtext">
                        Samriddhi Gurukul is your gateway to mastering real estate, whether you're a student, investor, or channel partner.
                    </p>
                    <div className="hero-buttons">
                        <button className="hero-btn primary">Explore Courses</button>
                        <button className="hero-btn secondary">Become a Channel Partner</button>
                    </div>
                </div>
            </section> */}


            <Hero />



            {/* -------------------About Section------------------- */}


            <section className="about-section">
                <h2 className="section-title">India’s Most Practical Real Estate Learning Platform</h2>
                <p className="section-subtext">
                    Samriddhi Gurukul is not just a training institute — it is a complete ecosystem designed to shape your real estate career.
                </p>

                <p className='section-subtext'>From expert-led training and industry-recognized certifications to hands-on field exposure and real business opportunities, we prepare you to succeed as a high-earning Real Estate Professional.</p>
                <p className='section-subtext'>Whether you're starting fresh or scaling your existing journey, Samriddhi Gurukul gives you the knowledge, network, and confidence to grow in the fastest-growing industry in India.</p>


                <div className="features-grid">
                    <div className="feature-box">
                        <div className="feature-icon">
                            {/* <img src={cap} alt='Experts' width={50} />  */}
                        </div>
                        <h3 className="feature-title">
                            {/* Expert-Led Training Sessions */}
                            Largest Asset class with untapped potential

                        </h3>
                        <p className="feature-text">
                            {/* Learn directly from top-performing industry professionals. */}

                            Real estate is india's largest asset

                        </p>
                    </div>
                    <div className="feature-box">
                        <div className="feature-icon">
                            {/* <img src={certified} alt='get certified' width={50} /> */}
                        </div>
                        <h3 className="feature-title">
                            {/* Practical Field Exposure */}
                            Digitizing the Real Estate Space

                        </h3>
                        <p className="feature-text">
                            {/* Real site visits, real clients, and real project experience. */}

                            We are revolutionizing property transaction in rural and semi urban markets by offering digital tools and professional services
                        </p>
                    </div>
                    <div className="feature-box">
                        <div className="feature-icon">
                            {/* <img src={grow} alt='grow professionally' width={50} /> */}
                        </div>
                        <h3 className="feature-title">
                            {/* Lifetime Access to Community */}
                            Franchise model for empowerment

                        </h3>
                        <p className="feature-text">
                            {/* A supportive ecosystem for ongoing learning and growth. */}

                            Our franchise model gives local entrepreneurs the tool,training and technology needed to succeed.

                        </p>
                    </div>
                </div>
            </section>


            {/* GK offerings */}

            <GurukulOffers />


            {/* ---------Franchise Partner Get------------- */}


            <PartnerGet />



            {/* -------PopularCourses Component---------- */}

            <PopularCourses />



        </>


    );
};

export default Home;
